import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const FileAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 8H19.4L14 2.6V7C14 7.6 14.4 8 15 8ZM15 10C13.3 10 12 8.7 12 7V2H7C5.3 2 4 3.3 4 5V19C4 20.7 5.3 22 7 22H17C18.7 22 20 20.7 20 19V10H15ZM9 8H10C10.6 8 11 8.4 11 9C11 9.6 10.6 10 10 10H9C8.4 10 8 9.6 8 9C8 8.4 8.4 8 9 8ZM15 18H9C8.4 18 8 17.6 8 17C8 16.4 8.4 16 9 16H15C15.6 16 16 16.4 16 17C16 17.6 15.6 18 15 18ZM15 14H9C8.4 14 8 13.6 8 13C8 12.4 8.4 12 9 12H15C15.6 12 16 12.4 16 13C16 13.6 15.6 14 15 14Z"
      fill="currentColor"
    />
  </svg>
)

export default FileAlt
